module.exports = __webpack_public_path__ + "img/apk_en.931dbcdb.jpg";